module.exports = __webpack_public_path__ + "static/media/6_5.65c8f1a6.jpg";